import { createRoot } from 'react-dom/client';
import 'sonner/dist/styles.css';

import { initApm } from '@/apm';
import { App } from '@/app';
import '@/index.css';

const bootstrap = async () => {
  /** 仅在显式配置 VITE_USE_MOCK=true 时启用运行时 MSW，默认走真实接口 */
  const shouldUseMock = import.meta.env.VITE_USE_MOCK === 'true';
  if (import.meta.env.DEV && shouldUseMock) {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }

  initApm();
  createRoot(document.getElementById('root')!).render(<App />);
};

bootstrap();
